const Section = ({ index, disabled = false, children }: { index: number, children: React.ReactNode, disabled?: boolean }): JSX.Element => {
  return (
    <div className={`flex gap-4 ${disabled && 'text-gray-400'}`}>
      <div className={`flex flex-none justify-center items-center w-10 h-10 rounded-full ${disabled ? 'bg-green-100' : 'bg-header'} font-bold`}>
        {index}
      </div>
      <div className={'w-full space-y-6 pt-2'}>
        {children}
      </div>
    </div>
  );
};

export {
  Section,
};
